import {
  FETCH_TEMPLATES,
  SET_TEMPLATE_OBJECT,
  CREATE_TEMPLATE_OBJECT,
  UPDATE_TEMPLATE_OBJECT,
} from '../actions/types'

const defaultState = {
  templates: [],
  template: {},
}

const templateState = (state = defaultState, action) => {
  const { type, payload } = action
  switch (type) {
    case FETCH_TEMPLATES:
      return {
        ...state,
        ...{
          templates: payload,
        },
      }
    case SET_TEMPLATE_OBJECT:
      return {
        ...state,
        ...payload,
      }
    case CREATE_TEMPLATE_OBJECT:
      return {
        ...state,
        templates: [...state.templates, payload],
      }
    case UPDATE_TEMPLATE_OBJECT:
      return {
        ...state,
        templates: [
          ...state.templates.map((template) => {
            // eslint-disable-line
            return template.id !== payload.id ? template : payload
          }),
        ],
      }
    default:
      return state
  }
}

export default templateState
